import { useState, useEffect } from 'react'
import { useParams, useNavigate } from "react-router-dom"
// ------ Services ------ //
import * as leadCaptureService from '../../../services/leadCaptureService'
import * as clientManagementService from '../../../services/clientManagementService'
import * as eventManagementService from '../../../services/eventManagementService'
import * as siteManagementService from '../../../services/siteManagementService'
// ------ Styles ------ //
import styles from "./LeadCaptureConfig.module.css"
// ------ Components ------ //
import SelectEvent from '../../../components/Account/ManageAccountSettings/SelectEvent'
import HoverButton from '../../../components/Miscellaneous/HoverButton'
import LCProduct from "../../../components/LeadCapture/LeadCaptureConfig/LCProduct"
import LoadingSpinner from '../../../components/Miscellaneous/LoadingSpinner'
const LeadCaptureConfig = () => {
    const navigate = useNavigate()
    const [loaded, setLoaded] = useState(false)
    const [products, setProducts] = useState([])
    const [create, setCreate] = useState(false)
    const [createRefresh, setCreateRefresh] = useState(false)
    const [sortedProducts, setSortedProducts] = useState([])
    const [defaultProducts, setDefaultProducts] = useState([])
    const [groups, setGroups] = useState([])
    const [attachments, setAttachments] = useState([])
    const [skus, setSKUs] = useState([])
    const [message, setMessage] = useState([''])
    const [clientOptions, setClientOptions] = useState([])
    const [eventOptions, setEventOptions] = useState([])
    const [headerFile, setHeaderFile] = useState();
    const [mobileFile, setMobileFile] = useState();
    const [editingId, setId] = useState();
    const [sorting, setSorting] = useState({ key: "productGroups", ascending: true });
    const [formData, setFormData] = useState(
        {
            leadCaptureId: null,
            client: {},
            clientName: null,
            overwriteName: null,
            statements: [],
            authStatement: '<div>I attest to the terms and conditions above. Checking this authorization checkbox implies that you have read, understood and agreed to be ' +
                'subject to the terms and conditions stipulated herein.\r\n</div><br />\r\n<div>\r\nA confirmation email with receipt will be emailed to you upon successful submission of ' +
                'your order. Instructions for picking up your equipment will also be provided.\r\n</div><br />\r\n<div>\r\n' +
                'For inquiries please email us at <a href=\"mailto:itevents@smithbucklin.com\">itevents@smithbucklin.com</a>\r\n</div>',
            regClosed: 'This events registration has closed.\r\n</div><br />\r\n<div>\r\nFor inquiries please email us at ' +
                '<a href=\"mailto:itevents@smithbucklin.com\">itevents@smithbucklin.com</a>\r\n</div>',
            termsAndConditions: '<h2>\r\n\tTerms &amp; Conditions</h2>\r\n<div>\r\n\tAll orders and usage of badge reader equipment are subject to the following' +
                ' terms &amp; conditions:</div>\r\n<div>\r\n\t<strong>1. Orders &amp; Order Timelines</strong></div>\r\n<div style=\"margin-left: 40px; \">\r\n\t&bull; ' +
                'All orders must be paid in full prior to picking up badge reader(s).</div>\r\n<div style=\"margin-left: 40px; \">\r\n\t&bull; Orders received after the ' +
                'stated deadline will be charged at the On-site rates without exception.</div>\r\n<div style=\"margin-left: 40px; \">\r\n\t&bull; Orders received on-site ' +
                'are subject to availability.</div>\r\n<div>\r\n\t&nbsp;</div>\r\n<div>\r\n\t<strong>2. Payment Terms and Cancellations&nbsp;</strong></div>\r\n' +
                '<div style=\"margin-left: 40px; \">\r\n\t&bull; Service will be rendered after receipt of full payment by credit card or check.</div>\r\n' +
                '<div style=\"margin-left: 40px; \">\r\n\t&bull; All cancelations made more than 14 days prior to the event will be subject to a $25 processing fee. ' +
                'No refunds will be issued for cancellation requests that are made 14 days prior to the event start date.</div>\r\n<div style=\"margin-left: 40px; \">\r\n\t&bull; ' +
                'Unclaimed badge readers or unused orders are not refundable.</div>\r\n<div>\r\n\t&nbsp;</div>\r\n<div>\r\n\t<strong>3. Equipment User Terms</strong></div>\r\n' +
                '<div style=\"margin-left: 40px; \">\r\n\t&bull; All hardware, software, and badge reading equipment belong to the provider.</div>\r\n<div style=\"margin-left: 40px; \">' +
                '\r\n\t&bull; If the badge reading equipment is not returned to the Lead Retrieval Desk within the hour following the end of the show, the user agrees to pay a late fee of ' +
                '$50 per day, up to a maximum of the cost of the unit. Replacement cost: $500.00</div>\r\n<div style=\"margin-left: 40px; \">\r\n\t&bull; If any badge reading equipment is' +
                ' lost, stolen, or damaged, the user will be responsible for said repair costs or replacement fee of $500 per unit.</div>\r\n<div>\r\n\t&nbsp;</div>\r\n<div>\r\n\t&nbsp;</div>' +
                '\r\n<div>\r\n\t<strong>4. Provider Responsibility and User Expectations</strong></div>\r\n<div style=\"margin-left: 40px; \">\r\n\t&bull; ' +
                'The User and provider each agree to indemnify, defend and hold harmless the other party and its respective successors and permitted assigns, and its officers, ' +
                'directors, members, agents, employees and/or representatives from and against any claim, action, cause of action, and liabilities including damages and expenses ' +
                '(including court costs and attorney fees and other fees of professionals) which may be asserted by third parties arising out of the performance of either party&rsquo;s ' +
                'obligations pursuant to the Services Rendered by the provider to the User, except for the willful misconduct or gross negligence of the other party.</div>\r\n' +
                '<div style=\"margin-left: 40px; \">\r\n\t&bull; &ldquo;Force Majeure&rdquo; shall refer to any cause or event(s) that is beyond the reasonable control of the SmithBucklin ' +
                'or the organizer of the meeting, that could not have been reasonably foreseen and prevented by means reasonably available to it, and that causes the Event(s) to be either ' +
                'canceled or postponed &ldquo;sine die&rdquo; and this term shall include but shall not be restricted to acts of God, civil unrest or of the public enemy, acts of the Government, ' +
                'fires, flood, epidemics, strikes, lockouts, curtailment of transportation facilities or service. In any such event of Force Majeure, the obligations of SmithBucklin for ' +
                'services not yet rendered shall become automatically terminated and SmithBucklin shall be entitled to retain all the payments already received.</div>\r\n<div>' +
                '\r\n\t&nbsp;</div>\r\n\r\n    <h2>Privacy Statement</h2>\r\n    <div id=\"PrivacyStatement\" style=\"margin-left: 40px; \">\r\n\t<br />\r\n\t<strong>What information do we ' +
                'collect? </strong><br />\r\n\t<br />\r\n\tWe collect information from you when you place an order.<br />\r\n\t<br />\r\n\tWhen ordering or registering on our site, as ' +
                'appropriate, you may be asked to enter your: name, e-mail address, mailing address, phone number or credit card information.<br />\r\n\t<br />\r\n\t<strong>What do we use ' +
                'your information for? </strong><br />\r\n\t<br />\r\n\tAny of the information we collect from you may be used in one of the following ways:<br />\r\n\t<br />\r\n\tTo process ' +
                'transactions<br />\r\n\t<br />\r\n\tContact you regarding your order<br />\r\n\t<br />\r\n\tConfirm your order and receipt<br />\r\n\t<br />\r\n\tYour information, whether ' +
                'public or private, will not be sold, exchanged, transferred, or given to any other company for any reason whatsoever, without your consent, other than for the express purpose ' +
                'of delivering the purchased product or service requested.</p>\r\n    <strong>How do we protect your information? </strong><br />\r\n\t<br />\r\n\tWe implement a variety of ' +
                'security measures to maintain the safety of your personal information when you place an order<br />\r\n\t<br />\r\n\tWe offer the use of a secure server. All supplied' +
                ' sensitive/credit information is transmitted via Secure Socket Layer (SSL) technology and then encrypted into our Payment gateway providers database only to be accessible ' +
                'by those authorized with special access rights to such systems, and are required to keep the information confidential.<br />\r\n\t<br />\r\n\tAfter a transaction, your private' +
                ' information (credit cards) will not be stored on our servers.<br />\r\n\t<br />\r\n\t<strong>Do we disclose any information to outside parties? </strong><br />\r\n\t<br />' +
                '\r\n\tWe do not sell, trade, or otherwise transfer to outside parties your personally identifiable information. This does not include trusted third parties who assist us in' +
                ' operating our website, conducting our business, or servicing you, so long as those parties agree to keep this information confidential. We may also release your information ' +
                'when we believe release is appropriate to comply with the law, enforce our site policies, or protect ours or others rights, property, or safety. However, non-personally ' +
                'identifiable visitor information may be provided to other parties for marketing, advertising, or other uses.<br />\r\n\t<br />\r\n\t<strong>Your Consent </strong><br />' +
                '\r\n\t<br />\r\n\tBy using our site, you consent to our privace policy.<br />\r\n\t<br />\r\n\t<strong>Changes to our Privacy Policy </strong><br />\r\n\t<br />\r\n\t' +
                'If we decide to change our privacy policy, we will post those changes on this page.</p>\r\n    </div>',
            receiptTemplate: '<!DOCTYPE html PUBLIC \"-//W3C//DTD XHTML 1.0 Transitional//EN\" \"http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd\">\r\n' +
                '<html xmlns=\"http://www.w3.org/1999/xhtml\">\r\n<head>\r\n\t<meta http-equiv=\"Content-Type\" content=\"text/html; charset=us-ascii\">\r\n</head>   \r\n\t<body>   ' +
                ' \r\n\t\t<style>    \r\n\t \r\n\t\t\t.email  {\r\n\t\t\twidth:700px;   \r\n\t\t\tmargin: 10px 0px 0px 0px;   \r\n\t\t\tborder-left: solid 1px #3D779F;   ' +
                '\r\n\t\t\tborder-right: solid 1px #3D779F;   \r\n\t\t\tborder-bottom: solid 1px #3D779F;  \r\n\t\t\t}  \r\n\t\t\t\r\n\t\t\t.header  {\r\n\t\t\tbackground-color:#3D779F;  ' +
                ' \r\n\t\t\theight: 10px;  }  \r\n\t\t\t\r\n\t\t\t.logo  {   \r\n\t\t\tborder-bottom: solid 1px #3D779F;  \r\n\t\t\t}    \r\n\t\t\t\r\n\t\t\t.emailContent  {  ' +
                ' \r\n\t\t\tpadding-top:10px;   \r\n\t\t\tpadding-bottom: 5px;   \r\n\t\t\tpadding-left:10px;   \r\n\t\t\tpadding-right:10px;  \r\n\t\t\tfont-family:Tahoma, Arial, Helvetica;   ' +
                '\r\n\t\t\t}      \r\n\t\t\t.footer  \r\n\t\t\t{   padding-top:5px;   \r\n\t\t\tpadding-bottom: 10px;   \r\n\t\t\tpadding-left:10px;   \r\n\t\t\tpadding-right:10px;  ' +
                ' \r\n\t\t\tcolor:  #003768;   \r\n\t\t\tfont-family:Tahoma, Arial, Helvetica;   \r\n\t\t\tfont-size: 12px;   \r\n\t\t\tfont-weight: normal;  }      \r\n\t\t</style>    ' +
                '  \r\n\t\t<div class=\"email\">          \r\n\t\t\t<div class=\"header\">&nbsp;</div>          \r\n\t\t\t<div class=\"logo\">     ' +
                '\r\n\t\t\t\t<img src={HEADERIMAGE} border=\"0\" complete=\"complete\">    \r\n\t\t\t</div>         ' +
                ' \r\n\t\t\t\r\n\t\t\t<div class=\"emailContent\">  \r\n\t\t\t\t{CONTENT}\r\n\t\t\t</div>          \r\n\t\t\t<div class=\"footer\">\r\n     <br />\r\n           ' +
                ' For all inquiries, please email us at <a href=\"mailto:itevents@smithbucklin.com\">itevents@smithbucklin.com</a>\r\n            </div>\r\n\t\t\t<div class=\"footer\">    ' +
                ' \r\n\t\t\t\t<p>330 N Wabash Suite 1800<br />\r\n                Chicago, IL 60611<br />\r\n\t\t\t\te: <a href=\"mailto:itevents@smithbucklin.com\">itevents@smithbucklin.com</a>  ' +
                '            \r\n\t\t\t\t</p>          \r\n\t\t\t</div>      \r\n\t\t</div>     \r\n\t</body>  \r\n</html>\r\n\r\n',
            errorTemplate: '<!DOCTYPE html PUBLIC \"-//W3C//DTD XHTML 1.0 Transitional//EN\" \"http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd\">\r\n' +
                '<html xmlns=\"http://www.w3.org/1999/xhtml\">\r\n<head>\r\n    <meta http-equiv=\"Content-Type\" content=\"text/html; charset=us-ascii\">\r\n</head>\r\n<body>\r\n' +
                '    <style>\r\n\r\n        .email {\r\n            width: 700px;\r\n            margin: 10px 0px 0px 0px;\r\n            border-left: solid 1px #3D779F;\r\n ' +
                '           border-right: solid 1px #3D779F;\r\n            border-bottom: solid 1px #3D779F;\r\n        }\r\n\r\n        .header {\r\n ' +
                '           background-color: #3D779F;\r\n            height: 10px;\r\n        }\r\n\r\n        .logo {\r\n            border-bottom: solid 1px #3D779F;\r\n   }\r\n\r\n' +
                '     .emailContent {\r\n            padding-top: 10px;\r\n            padding-bottom: 5px;\r\n            padding-left: 10px;\r\n            padding-right: 10px;\r\n   ' +
                '         font-family: Tahoma, Arial, Helvetica;\r\n        }\r\n\r\n        .footer {\r\n            padding-top: 5px;\r\n            padding-bottom: 10px;\r\n    ' +
                '        padding-left: 10px;\r\n            padding-right: 10px;\r\n            color: #003768;\r\n            font-family: Tahoma, Arial, Helvetica;\r\n      ' +
                '      font-size: 12px;\r\n            font-weight: normal;\r\n        }\r\n    </style>\r\n    <div class=\"email\">\r\n        <div class=\"header\">&nbsp;</div>\r\n   ' +
                '     <div class=\"logo\">\r\n            <img src={HEADERIMAGE} border=\"0\" complete=\"complete\">\r\n  ' +
                '      </div>\r\n\r\n        <div class=\"emailContent\">\r\n            {CONTENT}\r\n        </div>\r\n        <div class=\"footer\">\r\n         ' +
                '   <br />\r\n            fixable/expected link -c{FIXABLELINK}\r\n       ' +
                ' </div>\r\n    </div>\r\n</body>\r\n</html>\r\n\r\n',
            event1: {},
            eventName: null,
            event2: {},
            eventName2: null,
            event3: {},
            eventName3: null,
            event4: {},
            eventName4: null,
            headerImage: [],
            headerBase64Image: null,
            headerImageWidth: 980,
            headerImageHeight: 340,
            headerImageExtension: 'jpg',
            mobileImage: [],
            mobileBase64Image: null,
            mobileImageExtension: 'jpg',
            testEvent: false,
            eventStartDate: null,
            earlyRegistrationDeadline: null,
        }
    )
    const [formProductData, setFormProductData] = useState(
        {
            id: null,
            skuName: null,
            sku: {},
            name: null,
            description: null,
            regularPrice: null,
            onSitePrice: null,
            showQuantity: null,
            productGroups: null,
            productGroupsName: null,
            productOrdering: null,
            pdfAttachment: null,
            usePromoCode: null,
            promoCodes: null,
            isAdmin: null,
        }
    )
    const [firstEvent, setFirstEvent] = useState({
        event: {},
        eventName: null,
    })

    const [secondEvent, setSecondEvent] = useState({
        event: {},
        eventName: null,
    })

    const [thirdEvent, setThirdEvent] = useState({
        event: {},
        eventName: null,
    })

    const [fourthEvent, setFourthEvent] = useState({
        event: {},
        eventName: null,
    })
    const clearFirstEvent = () => setFirstEvent({
        event: null,
        eventName: null,
    })
    const clearSecondEvent = () => setSecondEvent({
        event: null,
        eventName: null,
    })
    const clearThirdEvent = () => setThirdEvent({
        event: null,
        eventName: null,
    })
    const clearFourthEvent = () => setFourthEvent({
        event: null,
        eventName: null,
    })

    const ClearAllEvents = () => {
        clearFirstEvent();
        clearSecondEvent();
        clearThirdEvent();
        clearFourthEvent();
    }
    const createEventsRequestBody = async () => {

        let requestBody = {}

        if (formData.client && formData.client.clientId) {
            requestBody =
            {
                clientId: formData.client.clientId,
                clientName: formData.client.clientName,
            }
        }

        return await requestBody;
    }
    const { leadCaptureId } = useParams()
    const fetchClients = async () => {
        const clients = await clientManagementService.getClients();
        setClientOptions(clients);
    }
    const setEventAssignments = async () => 
    {
        // try to set events
        if (formData.eventId) {
            var foundEvent = eventOptions.find((item) => item.eventId === formData.eventId);
            if (foundEvent) {
                let event1 = {
                    event: foundEvent,
                    eventName: foundEvent.name
                }
                setFirstEvent(event1);
            }
        }
        if (formData.eventId2) {
            var foundEvent2 = eventOptions.find((item) => item.eventId === formData.eventId2);
            if (foundEvent2) {
                let event2 = {
                    event: foundEvent2,
                    eventName: foundEvent2.name
                }
                setSecondEvent(event2);
            }
        }
        if (formData.eventId3) {
            var foundEvent3 = eventOptions.find((item) => item.eventId === formData.eventId3);
            if (foundEvent3) {
                let event3 = {
                    event: foundEvent3,
                    eventName: foundEvent3.name
                }
                setThirdEvent(event3);
            }
        }
        if (formData.eventId4) {
            var foundEvent4 = eventOptions.find((item) => item.eventId === formData.eventId4);
            if (foundEvent4) {
                let event4 = {
                    event: foundEvent4,
                    eventName: foundEvent4.name
                }
                setFourthEvent(event4);
            }
        }
    }
    const fetchEvents = async () => {
        let req = await createEventsRequestBody();
        const events = await eventManagementService.loadEvents(req);
        setEventOptions(events);
    }
    const createSaveRequest = (items) => {
        if (firstEvent) {
            formData.event1 = firstEvent.event;
            formData.eventName = firstEvent.eventName;
        }
        if (secondEvent) {
            formData.event2 = secondEvent.event;
            formData.eventName2 = secondEvent.eventName;
        }
        if (thirdEvent) {
            formData.event3 = thirdEvent.event;
            formData.eventName3 = thirdEvent.eventName;
        }
        if (fourthEvent) {
            formData.event4 = fourthEvent.event;
            formData.eventName4 = fourthEvent.eventName;
        }
        let newProductList = [];
        sortedProducts.forEach((product) => {
            const groupItems = Array.from(groups)
            let groupName = groupItems[product.productGroups]
            product.productGroupsName = groupName.name;
            const productItems = Array.from(sortedProducts)//Array.from(products)
            let productName = productItems.find((item) => item.sku === product.sku); //.find((item) => item.name === formData.eventName4);
            product.skuName = productName.skuName;
            newProductList.push(product)
        })
        let statements = {
            'authStatement': formData.authStatement,
            'regClosed': formData.regClosed,
            'termsAndConditions': formData.termsAndConditions,
            'receiptTemplate': formData.receiptTemplate,
            'errorTemplate': formData.errorTemplate,
        };

        const fieldsSave = {
            'leadCaptureId': formData.id,
            'clientId': formData.client.clientId,
            'clientName': formData.client.clientName,
            'overwriteName': formData.overwriteName,
            'eventId': formData.event1 && formData.event1.eventId ? formData.event1.eventId : null,
            'eventName1': formData.eventName ? formData.eventName : null,
            'eventId2': formData.event2 && formData.event2.eventId ? formData.event2.eventId : null,
            'eventName2': formData.eventName2 ? formData.eventName2 : null,
            'eventId3': formData.event3 && formData.event3.eventId ? formData.event3.eventId : null,
            'eventName3': formData.eventName3 ? formData.eventName3 : null,
            'eventId4': formData.event4 && formData.event4.eventId ? formData.event4.eventId : null,
            'eventName4': formData.eventName4 ? formData.eventName4 : null,
            'headerBase64Image': formData.headerBase64Image ? formData.headerBase64Image : null,
            'headerImageWidth': formData.headerImageWidth ? formData.headerImageWidth : 980,
            'headerImageHeight': formData.headerImageHeight ? formData.headerImageHeight : 340,
            'headerImageExtension': formData.headerImageExtension ? formData.headerImageExtension : 'jpg',
            'mobileBase64Image': formData.mobileBase64Image ? formData.mobileBase64Image : null,
            'mobileImageExtension': formData.mobileImageExtension ? formData.mobileImageExtension : 'jpg',
            'products': newProductList,
            'statements': statements,
            'testEvent': formData.testEvent,
            'eventStartDate': formData.eventStartDate,
            'earlyRegistrationDeadline': formData.earlyRegistrationDeadline,
        }
        return fieldsSave
    }
    const handleProductChange = (e) => {
        if (e.target.type === 'select-one') {
            if (e.target.name === "productGroupsName") {
                var foundGroup = groups.find((item) => item.name === e.target.value);
                if (foundGroup) {
                    formProductData.group = foundGroup;
                    formProductData.productGroups = foundGroup.id;
                    formProductData.productGroupsName = foundGroup.name
                }
                else {
                    formProductData.group = null;
                    formProductData.productGroups = null;
                }
            }
            else if (e.target.name === "pdfAttachment") {
                var foundAttachment = attachments.find((item) => item.fileName === e.target.value);
                if (foundAttachment) {
                    formProductData.pdfAttachment = foundAttachment.fileName;
                }
                else {
                    formProductData.pdfAttachment = null;
                }
            }
            else {
                var foundProduct = defaultProducts.find((item) => item.skuName === e.target.value);
                if (foundProduct) {
                    formProductData.sku = foundProduct;
                }
                else {
                    formProductData.sku = null;
                }
                formProductData.skuName = foundProduct.skuName
            }
            setFormProductData({
                ...formProductData
            })
        }
        else if (e.target.type === 'checkbox') {
            formProductData[e.target.name] = e.target.checked;
            setFormProductData({
                ...formProductData
            })
        }
        else if (e.target.type === 'number') {
            formProductData[e.target.name] = parseInt(e.target.value);
            setFormProductData({
                ...formProductData
            })
        }
        else {
            formProductData[e.target.name] = e.target.value;
            setFormProductData({
                ...formProductData
            })
        }
    }
    
    const handleChange = (e) => {
        if (e.target.type === 'select-one') {
            if (e.target.name === "clientName") {
                var foundClient = clientOptions.find((item) => item.clientName === e.target.value);
                if (foundClient) {
                    setFormData({
                        ...formData,
                        client: foundClient,
                        clientName: foundClient.clientName,
                    })
                }
            }

        }
        else if (e.target.type === 'checkbox') {
            setFormData({
                ...formData,
                [e.target.name]: e.target.checked,
            })
        }
        else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value,
            })
        }
    }
    const clearForm = () => {
        setFormProductData({
            id: null,
            skuName: null,
            sku: {},
            name: null,
            description: null,
            regularPrice: null,
            onSitePrice: null,
            showQuantity: null,
            productGroups: null,
            productGroupsName: null,
            productOrdering: null,
            pdfAttachment: null,
            usePromoCode: null,
            promoCodes: null,
            isAdmin: null,
        })
    }
    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => {
                const base64 = reader.result.split(',')[1]
                resolve(base64)
            }
            reader.onerror = (error) => {
                reject(error)
            }
        })
    }
    async function handleFileChange(e) {
        //https://stackoverflow.com/questions/39092859/get-dimensions-of-image-with-react
        //console.log(e.target.files);
        if (e.target.name === "headerImage") {
            setHeaderFile(URL.createObjectURL(e.target.files[0]));
            //formData.headerImageExtension = e.target.files[0].type;
            formData.headerBase64Image = await getBase64(e.target.files[0]);
        }
        if (e.target.name === "mobileImage") {
            setMobileFile(URL.createObjectURL(e.target.files[0]));
            //formData.mobileImageExtension = e.target.files[0].type;
            formData.mobileBase64Image = await getBase64(e.target.files[0]);
        }
    }

    const handleProductSubmit = async e => {
        e.preventDefault()
        // add to products
        let newArray = sortedProducts;
        newArray.push(formProductData);
        setSortedProducts(newArray);
        setProducts(newArray);

        setCreate(false)
        clearForm();
        setCreateRefresh(true)
    }
    const handleSubmit = async e => {
        e.preventDefault()
        try {
            let saveReq = createSaveRequest();
            await leadCaptureService.updateEvent(saveReq);
            navigate('/LeadCaptureList');
        } catch (err) {
            setMessage(err.message)
        }
    }
    const createProduct = e => {
        e.preventDefault()
        // keeps previous entry, if cancelled
        setCreate(create ? false : true)
    }
    const editProduct = e => {
        e.preventDefault()
        let divId = e.currentTarget.id
        //if (!divId) {
        //    e.current.id
        //}
        const items = Array.from(sortedProducts)// Array.from(products)
        let filtered = items[divId]

        // Have to add this to maintain one edit at a time, since all will share formData for editing state
        const editableCheck = i => i.editable
        if (items.some(editableCheck)) {
            return
        }
        filtered.editable = true
        setId(divId)
    }
    const submitEdit = (e, prodItem) => {
        e.preventDefault()
        let divId = e.currentTarget.id
        const items = Array.from(sortedProducts)
        prodItem.editable = false;
        items.splice(divId, 1, prodItem);
        setSortedProducts(items);
        setProducts(items);
        setId(null)
    }

    const deleteProduct = e => {
        e.preventDefault()
        let divId = e.currentTarget.id
        //if (!divId) {
        //    e.current.id
        //}
        const items = Array.from(sortedProducts)//Array.from(products)
        let filtered = items[divId]
        let trimmed = [];
        for (var i = 0; i < items.length; i++) {
            if (items[i] === filtered) {
                trimmed = items.splice(i, 1);
                i--;
            }
        }
        setSortedProducts(items);
        setProducts(items);
        // Have to add this to maintain one edit at a time, since all will share formData for editing state
        const editableCheck = i => i.editable
        if (!items.some(editableCheck)) {
            return
        }
        filtered.editable = false
        setId(null)
    }

    const cancelEdit = e => {
        e.preventDefault()
        let divId = e.currentTarget.id
        //if (!divId) {
        //    e.current.id
        //}
        const items = Array.from(sortedProducts)//Array.from(products)
        let filtered = items[divId]

        // Have to add this to maintain one edit at a time, since all will share formData for editing state
        const editableCheck = i => i.editable
        if (!items.some(editableCheck)) {
            return
        }
        filtered.editable = false
        setId(null)
    }
    const applySort = () => {
        // apply sorting, have to create copy to trigger re-rendering
        let newArray = sortedProducts.sort((a, b) => a.productGroups - b.productGroups || a.productOrdering - b.productOrdering);
        setSortedProducts([...newArray]);
    }
    const isFormValid = () => {
        return formData.clientName
            && formData.overwriteName
            && formData.earlyRegistrationDeadline
            && formData.authStatement
            ? true
            : false
    }
    const isProductFormValid = () => {
        return formProductData.name
            && formProductData.sku
            && formProductData.description
            && formProductData.productGroupsName
            ? true
            : false
    }
    const fetchDefaultProducts = async () => {
        const defaultProducts = await leadCaptureService.getDefaultProducts();
        setDefaultProducts(defaultProducts);
        if (leadCaptureId && leadCaptureId !== undefined) {
            // do nothing
        }
        else {
            setSortedProducts(defaultProducts);
            setProducts(defaultProducts);
        }
    }
    const fetchGroups = async () => {
        const groupItems = await leadCaptureService.getGroups()
        if (groupItems && groupItems.length > 0) {
            setGroups(groupItems);
        }
        else {
            setGroups([]);
        }
    }
    const fetchSKUs = async () => {
        const skuItems = await leadCaptureService.getSKUs();
        if (skuItems && skuItems.length > 0) {
            setSKUs(skuItems);
        }
        else {
            setSKUs([]);
        }
    }
    const fetchAttachments = async () => {
        const attachmentItems = await siteManagementService.getAttachmentsByType('marketing');
        if (attachmentItems && attachmentItems.length > 0) {
            setAttachments(attachmentItems);
        }
        else {
            setAttachments([]);
        }
    }
    const fetchEvent = async () => {
        const eventItem = await leadCaptureService.getEvent(leadCaptureId);
        // set formdata
        if (eventItem) {
            eventItem.clientName = eventItem.client.clientName;
            eventItem.authStatement = eventItem.statements.authStatement;
            eventItem.regClosed = eventItem.statements.regClosed;
            eventItem.termsAndConditions = eventItem.statements.termsAndConditions;
            eventItem.receiptTemplate = eventItem.statements.receiptTemplate;
            eventItem.errorTemplate = eventItem.statements.errorTemplate;
            setFormData(eventItem);

            if (eventItem.headerBase64Image) {
                setHeaderFile(eventItem.headerBase64Image)
            }
            if (eventItem.mobileBase64Image) {
                setMobileFile(eventItem.mobileBase64Image)
            }
            if (eventItem.products && eventItem.products.length > 0) {
                setSortedProducts(eventItem.products);
                setProducts(eventItem.products);
            }
        }
    }

    useEffect(() => {
        if (eventOptions && eventOptions.length > 0) {
            setEventAssignments();
        }
    }, [eventOptions])
    useEffect(() => {
        if (formData.clientName && clientOptions && clientOptions.length > 0) {
            ClearAllEvents();
            // try to set client
            var foundClient = clientOptions.find((item) => item.clientName === formData.clientName);
            if (foundClient) {
                setFormData({
                    ...formData,
                    'client': foundClient,
                })
                fetchEvents();
            }
            else {
                setFormData({
                    ...formData,
                    'client': null,
                })
                setFormData({
                    ...formData,
                    'clientName': null,
                })
            }
        }

    }, [formData.clientName])
    useEffect(() => {
        if (sortedProducts && sortedProducts.length > 0) {
            applySort();
        }
    }, [sortedProducts])
    useEffect(() => {
        // used for dropdowns
        fetchAttachments();
        // used for dropdowns
        fetchGroups();
        // used for dropdowns
        fetchSKUs();
        // used for dropdowns
        fetchDefaultProducts();
        // pull clients, used for dropdowns
        fetchClients();
        if (leadCaptureId && leadCaptureId !== undefined) {
            fetchEvent();
        }
        setLoaded(true);
    }, [])

    return (
        <>{loaded ?
            <>
                {leadCaptureId ?
                    <h1>Edit Lead Capture Event</h1>
                    :
                    <h1>Add Lead Capture Event</h1>
                }
                <div className={styles.eventContainer}>
                    <h2>Event Setup</h2>
                    <div className={styles.parentContainer}>
                        <div className={styles.leftContainer}>
                            <div className={styles.parentContainer}>
                                <div className={styles.leftContainer}>
                                    <label htmlFor="overwriteName" className={styles.label}>Lead Capture Name:
                                        <HoverButton
                                            title={'Name that will appear in displays.'}
                                            messageWidth={75}
                                        />
                                    </label>
                                </div>
                                <div className={styles.rightContainer}>
                                    <input
                                        type="text"
                                        autoComplete="off"
                                        name="overwriteName"
                                        value={formData.overwriteName}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={styles.rightContainer}>
                            <div className={styles.parentContainer}>
                            </div>
                        </div>
                    </div>
                    <div className={styles.parentContainer}>
                        <div className={styles.leftContainer}>
                            <div className={styles.parentContainer}>
                                <div className={styles.leftContainer}>
                                    <label htmlFor="earlyRegistrationDeadline" className={styles.label}>Early Registration Date:
                                        <HoverButton
                                            title={'Lead Capture early registration date.'}
                                            messageWidth={75}
                                        />
                                    </label>
                                </div>
                                <div className={styles.rightContainer}>
                                    <input
                                        type="date"
                                        autoComplete="off"
                                        value={formData.earlyRegistrationDeadline ? formData.earlyRegistrationDeadline.split('T')[0] : ''}
                                        name="earlyRegistrationDeadline"
                                        onChange={handleChange}
                                        className={styles.datePicker}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={styles.rightContainer}>
                            <div className={styles.parentContainer}>
                                <div className={styles.leftContainer}>
                                    <label htmlFor="eventStartDate" className={styles.label}>Start Date:
                                        <HoverButton
                                            title={'Date used for event.'}
                                            messageWidth={75}
                                        />
                                    </label>
                                </div>
                                <div className={styles.rightContainer}>
                                    <input
                                        type="date"
                                        autoComplete="off"
                                        value={formData.eventStartDate ? formData.eventStartDate.split('T')[0] : ''}
                                        name="eventStartDate"
                                        onChange={handleChange}
                                        className={styles.datePicker}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={styles.parentContainer}>
                        <div className={styles.leftContainer}>
                            <div className={styles.parentContainer}>
                                <div className={styles.leftContainer}>
                                    <h4>Header Image Option </h4>
                                    <h3>Image height default is 340, smaller sizes will have margin around them.<br />
                                        Image width default is 980, smaller sizes will have margin around them.
                                    </h3>
                                    <h3>Header Image:</h3>
                                    <div className={styles.leftThird}>
                                        <div className={styles.inputContainer}>
                                            <label className={styles.label} title="Set expected height of image, not actual.">
                                                Header Image Height: <input
                                                    type="text"
                                                    value={formData.headerImageHeight}
                                                    name="headerImageHeight"
                                                    onChange={handleChange}
                                                />

                                            </label>

                                        </div>
                                    </div>
                                    <div className={styles.middleThird}>
                                        <div className={styles.inputContainer}>
                                            <label className={styles.label} title="Set expected width of image, not actual.">
                                                Header Image Width: <input
                                                    type="text"
                                                    value={formData.headerImageWidth}
                                                    name="headerImageWidth"
                                                    onChange={handleChange}
                                                />

                                            </label>

                                        </div>
                                    </div>
                                    <div className={styles.rightThird}>
                                        <div className={styles.inputContainer}>
                                            <label className={styles.label} title="Extension of image, can't be changed.">
                                                Header Image Extension: <input
                                                    type="text"
                                                    value={formData.headerImageExtension}
                                                    name="headerImageExtension"
                                                    onChange={handleChange}
                                                    disabled={true}
                                                />

                                            </label>

                                        </div>
                                    </div>
                                    <img src={headerFile} />
                                    <input type="file" onChange={handleFileChange} name="headerImage" />
                                </div>
                                <div className={styles.rightContainer}>
                                    <h4>Mobile Image Option </h4>
                                    <h3>Image should be close to 400x100.
                                    </h3>
                                    <h3>Mobile Image:</h3>
                                    <img src={mobileFile} />
                                    <input type="file" onChange={handleFileChange} name="mobileImage" />
                                    <div className={styles.inputContainer}>
                                        <label className={styles.label} title="Extension of image, can't be changed.">
                                            Mobile Image Extension: <input
                                                type="text"
                                                value={formData.mobileImageExtension}
                                                name="mobileImageExtension"
                                                onChange={handleChange}
                                                disabled={true}
                                            />

                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.rightContainer}>
                            <div className={styles.parentContainer}>
                                <div className={styles.leftContainer}>
                                    <label htmlFor="testEvent" className={styles.label}>Test Event:
                                        <HoverButton
                                            title={'True - event will be filtered from public lists.'}
                                            messageWidth={75}
                                        />
                                    </label>
                                </div>
                                <div className={styles.rightContainer}>
                                    <input
                                        type="checkbox"
                                        autoComplete="off"
                                        checked={formData.testEvent ? true : false}
                                        name="testEvent"
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div><br/>
                    <div className={styles.parentContainer}>
                        <div className={styles.leftContainer}>
                            <label htmlFor="clientName" className={styles.label}>Select Client:
                                <HoverButton
                                    title={'Client assignment.'}
                                    messageWidth={75}
                                />
                            </label>
                        </div>
                        <div className={styles.rightContainer}>
                            <select
                                name="clientName"
                                id={styles.ThirdPartyListDropdown}
                                value={formData.clientName}
                                onChange={handleChange}
                            >
                                <option disabled={true} value="" selected="selected">
                                    -- Select an option --
                                </option>
                                {
                                    clientOptions.map((ci, idx) => (
                                        <option key={idx}>{ci.clientName}</option>
                                    ))
                                }
                            </select>
                        </div>
                    </div>
                    <h3 style={{ textAlign: 'center' }}>Assign up to 4 ERS events to each Lead Capture event.</h3>
                    {formData.clientName && formData.client ?
                        <div className={styles.parentContainer}>
                            <div className={styles.leftContainer}>
                                <SelectEvent
                                    formData={formData}
                                    eventInfo={firstEvent}
                                    setEvent={setFirstEvent}
                                    listEvents={eventOptions}
                                    key={formData.clientName ? formData.clientName + "1" : "1"}
                                />
                            </div>
                            <div className={styles.rightContainer}>
                                {formData.clientName && formData.client && firstEvent && firstEvent.eventName ?
                                    <SelectEvent
                                        formData={formData}
                                        eventInfo={secondEvent}
                                        setEvent={setSecondEvent}
                                        listEvents={eventOptions}
                                        key={formData.clientName ? formData.clientName + "2" : "2"}
                                    />
                                    : <></>
                                }
                            </div>
                        </div>
                        : <></>
                    }
                    {formData.clientName && formData.client ?
                        <div className={styles.parentContainer}>
                            <div className={styles.leftContainer}>
                                {formData.clientName && formData.client && secondEvent && secondEvent.eventName ?
                                    <SelectEvent
                                        formData={formData}
                                        eventInfo={thirdEvent}
                                        setEvent={setThirdEvent}
                                        listEvents={eventOptions}
                                        key={formData.clientName ? formData.clientName + "3" : "3"}
                                    />
                                    : <></>
                                }
                            </div>
                            <div className={styles.rightContainer}>
                                {formData.clientName && formData.client && thirdEvent && thirdEvent.eventName ?
                                    <SelectEvent
                                        formData={formData}
                                        eventInfo={fourthEvent}
                                        setEvent={setFourthEvent}
                                        listEvents={eventOptions}
                                        key={formData.clientName ? formData.clientName + "4" : "4"}
                                    />
                                    : <></>
                                }
                            </div>
                        </div>
                        : <></>
                    }
                </div>
                <hr style={{ height: '3px', 'border-width': '0', color: 'gray', 'background-color': 'gray' }}></hr>
                <div className={styles.tableProductsContainer}>
                    <h2>Products</h2>
                    <div className={styles.formProductContainer}>
                        <button onClick={createProduct} >
                            {!create ? "Add New Product" : "Cancel"}
                        </button><br />
                    </div>
                    {
                        create ?
                            <>
                                <div className={styles.formProductContainer}>
                                    <form
                                        autoComplete="off"
                                        onSubmit={handleProductSubmit}
                                        className={styles.container}
                                    >
                                        <div className={styles.inputContainer}>
                                            <label htmlFor="skuName" title='Product SKU.' className={styles.label}>SKU:</label>
                                            <select
                                                name="skuName"
                                                id={styles.ThirdPartyListDropdown}
                                                value={formProductData.skuName}
                                                onChange={handleProductChange}
                                                className={styles.fitCell}
                                            >
                                                <option disabled={true} value="" selected="selected">
                                                    -- Select an option --
                                                </option>
                                                {
                                                    defaultProducts.map((ci, idx) => (
                                                        <option key={idx}>{ci.skuName}</option>
                                                    ))
                                                }
                                            </select>
                                        </div>
                                        <div className={styles.inputContainer}>
                                            <label htmlFor="name" title='Product display name.' className={styles.label}>Name:</label>
                                            <input
                                                type="text"
                                                value={formProductData.name}
                                                name="name"
                                                onChange={handleProductChange}
                                                className={styles.fitCell}
                                            />
                                        </div>
                                        <div className={styles.inputContainer}>
                                            <label htmlFor="description" title='Product description.' className={styles.label}>Description:</label>
                                            <textarea
                                                type="text"
                                                value={formProductData.description}
                                                name="description"
                                                onChange={handleProductChange}
                                                rows="4"
                                                cols="40"
                                                className={styles.fitCell}
                                            />
                                        </div>
                                        <div className={styles.inputContainer}>
                                            <label htmlFor="regularPrice" title='Regular price.' className={styles.label}>Regular Price:</label>
                                            <input
                                                type="number"
                                                value={formProductData.regularPrice}
                                                name="regularPrice"
                                                onChange={handleProductChange}
                                                className={styles.fitCell}
                                            />
                                        </div>
                                        <div className={styles.inputContainer}>
                                            <label htmlFor="onSitePrice" title='Onsite price.' className={styles.label}>Onsite Price:</label>
                                            <input
                                                type="number"
                                                value={formProductData.onSitePrice}
                                                name="onSitePrice"
                                                onChange={handleProductChange}
                                                className={styles.fitCell}
                                            />
                                        </div>
                                        <div className={styles.inputContainer}>
                                            <label htmlFor="showQuantity" title='Show quantity.' className={styles.label}>Show Quantity:</label>
                                            <input
                                                type="checkbox"
                                                checked={formProductData.showQuantity}
                                                name="showQuantity"
                                                onChange={handleProductChange}
                                                className={styles.fitCell}
                                            />
                                        </div>
                                        <div className={styles.inputContainer}>
                                            <label htmlFor="productGroupsName" title='Product display group.' className={styles.label}>Product Group:</label>
                                            <select
                                                name="productGroupsName"
                                                id={styles.ThirdPartyListDropdown}
                                                value={formProductData.productGroupsName}
                                                onChange={handleProductChange}
                                                className={styles.fitCell}
                                            >
                                                <option disabled={true} value="" selected="selected">
                                                    -- Select an option --
                                                </option>
                                                {
                                                    groups.map((ci, idx) => (
                                                        <option key={idx}>{ci.name}</option>
                                                    ))
                                                }
                                            </select>
                                        </div>
                                        <div className={styles.inputContainer}>
                                            <label htmlFor="productOrdering" title='Product group order.' className={styles.label}>Product Group Order:</label>
                                            <input
                                                type="number"
                                                value={formProductData.productOrdering}
                                                name="productOrdering"
                                                onChange={handleProductChange}
                                                className={styles.fitCell}
                                            />
                                        </div>
                                        <div className={styles.inputContainer}>
                                            <label htmlFor="pdfAttachment" title='PDF name.' className={styles.label}>PDF Attachment:</label>
                                            <select
                                                name="pdfAttachment"
                                                id={styles.ThirdPartyListDropdown}
                                                value={formProductData.pdfAttachment}
                                                onChange={handleProductChange}
                                                className={styles.fitCell}
                                            >
                                                <option disabled={true} value="" selected="selected">
                                                    -- Select an option --
                                                </option>
                                                {
                                                    attachments.map((ci, idx) => (
                                                        <option key={idx}>{ci.fileName}</option>
                                                    ))
                                                }
                                            </select>
                                        </div>
                                        <div className={styles.inputContainer}>
                                            <label htmlFor="usePromoCode" title='Allow promo codes.' className={styles.label}>Use Promo Code:</label>
                                            <input
                                                type="checkbox"
                                                checked={formProductData.usePromoCode}
                                                name="usePromoCode"
                                                onChange={handleProductChange}
                                                className={styles.fitCell}
                                            />
                                        </div>
                                        <div className={styles.inputContainer}>
                                            <label htmlFor="promoCodes" title='Promo codes.' className={styles.label}>Promo Codes:</label>
                                            <input
                                                type="text"
                                                value={formProductData.promoCodes}
                                                name="promoCodes"
                                                onChange={handleProductChange}
                                                className={styles.fitCell}
                                            />
                                        </div>
                                        <div className={styles.inputContainer}>
                                            <label htmlFor="isAdmin" title='True - admin access only.' className={styles.label}>Is Admin:</label>
                                            <input
                                                type="checkbox"
                                                checked={formProductData.isAdmin}
                                                name="isAdmin"
                                                onChange={handleProductChange}
                                                className={styles.fitCell}
                                            />
                                        </div>
                                        <div className={styles.inputContainer}>
                                            <button disabled={!isProductFormValid()} className={styles.button}>
                                                Submit
                                            </button>
                                        </div>
                                    </form>

                                </div>
                            </>
                            :
                            <></>
                    }
                    <table className={styles.tableProducts}>
                        <thead>
                            <tr className={styles.trProducts}>

                                <th className={styles.thProducts} style={{ width: '7%' }}>
                                    SKU
                                    <HoverButton
                                        title={'SKU (Stock Keeping Unit) - inventory id.'}
                                        messageWidth={75}
                                    />
                                </th>
                                <th className={styles.thProducts} style={{ width: '15%' }}>
                                    Name
                                    <HoverButton
                                        title={'Label for product.'}
                                        messageWidth={75}
                                    />
                                </th>
                                <th className={styles.thProducts} style={{ width: '25%' }}>
                                    Description
                                    <HoverButton
                                        title={'Description for product.'}
                                        messageWidth={75}
                                    />
                                </th>
                                <th className={styles.thProducts} style={{ width: '5%' }}>
                                    Regular Price
                                    <HoverButton
                                        title={'Price before event/onsite.'}
                                        messageWidth={75}
                                    />
                                </th>
                                <th className={styles.thProducts} style={{ width: '5%' }}>
                                    OnSite Price
                                    <HoverButton
                                        title={'Price at event/onsite.'}
                                        messageWidth={75}
                                    />
                                </th>
                                <th className={styles.thProducts} style={{ width: '3%' }}>
                                    Show Quantity
                                    <HoverButton
                                        title={'Allow quantity selection.'}
                                        messageWidth={75}
                                    />
                                </th>

                                <th className={styles.thProducts} style={{ width: '7%' }}>
                                    Layout Group
                                    <HoverButton
                                        title={'Product layout grouping (default is GroupA).'}
                                        messageWidth={75}
                                    />
                                </th>
                                <th className={styles.thProducts} style={{ width: '3%' }}>
                                    Layout Group Order
                                    <HoverButton
                                        title={'Product list ordering (within group).'}
                                        messageWidth={75}
                                    />
                                </th>
                                <th className={styles.thProducts} style={{ width: '12%' }}>
                                    PDF Attachment
                                    <HoverButton
                                        title={'PDF to be used for product details.'}
                                        messageWidth={75}
                                    />
                                </th>
                                <th className={styles.thProducts} style={{ width: '3%' }}>
                                    Use Promo Codes
                                    <HoverButton
                                        title={'Allows for entry of promocode.'}
                                        messageWidth={75}
                                    />
                                </th>
                                <th className={styles.thProducts} style={{ width: '8%' }}>
                                    Promo Codes
                                    <HoverButton
                                        title={'Acceptable promocodes ( "||" seperated).'}
                                        messageWidth={75}
                                    />
                                </th>
                                <th className={styles.thProducts} style={{ width: '3%' }}>
                                    Is Admin
                                    <HoverButton
                                        title={'Only accessible by admin.'}
                                        messageWidth={75}
                                    />
                                </th>
                                <th className={styles.thProducts} style={{ width: '4%' }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody key={sortedProducts.length}>
                            {sortedProducts.map((item, index) => (
                                <LCProduct
                                    index={index}
                                    productItem={item}
                                    editProduct={editProduct}
                                    submitEdit={submitEdit}
                                    deleteProduct={deleteProduct}
                                    cancelEdit={cancelEdit}
                                    editingId={editingId}
                                    groups={groups}
                                    attachments={attachments}
                                    defaultProducts={defaultProducts}
                                    skus={skus}
                                    key={index}
                                ></LCProduct>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className={styles.submitButton}>
                    <button disabled={!isFormValid()} className={styles.button} onClick={handleSubmit}>
                        Submit
                    </button>
                </div>
                <hr style={{ height: '3px', 'border-width': '0', color: 'gray', 'background-color': 'gray' }}></hr>
                <div className={styles.eventContainer}>
                    <h2>Event Statements</h2>
                    <h4 className={styles.h4Message}>Don't change unless its necessary. Curly bracket &#123; &#125; contained items are required variables!</h4>
                    <div className={styles.parentContainer}>
                        <div className={styles.leftContainer}>
                            <div className={styles.parentContainer}>
                                <div className={styles.leftContainer}>
                                    <label htmlFor="authStatement" className={styles.label}>Authorization Statement:
                                        <HoverButton
                                            title={'Checkbox authorization statement.'}
                                            messageWidth={75}
                                        />
                                    </label>
                                </div>
                                <div className={styles.rightContainer}>
                                    <textarea
                                        type="textarea"
                                        autoComplete="off"
                                        value={formData.authStatement}
                                        name="authStatement"
                                        rows="10"
                                        cols="45"
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={styles.rightContainer}>
                            <div className={styles.parentContainer}>
                                <div className={styles.leftContainer}>
                                    <label htmlFor="regClosed" className={styles.label}>Registration Closed Statement:
                                        <HoverButton
                                            title={'Message to display after registration date.'}
                                            messageWidth={75}
                                        />
                                    </label>
                                </div>
                                <div className={styles.rightContainer}>
                                    <textarea
                                        type="textarea"
                                        autoComplete="off"
                                        value={formData.regClosed}
                                        name="regClosed"
                                        rows="10"
                                        cols="45"
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.parentContainer}>
                        <div className={styles.leftContainer}>
                            <div className={styles.parentContainer}>
                                <div className={styles.leftContainer}>
                                    <label htmlFor="termsAndConditions" className={styles.label}>Terms & Conditions Statement:
                                        <HoverButton
                                            title={'Terms and conditions agreement statement.'}
                                            messageWidth={75}
                                        />
                                    </label>
                                </div>
                                <div className={styles.rightContainer}>
                                    <textarea
                                        type="textarea"
                                        autoComplete="off"
                                        value={formData.termsAndConditions}
                                        name="termsAndConditions"
                                        rows="10"
                                        cols="45"
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={styles.rightContainer}>
                            <div className={styles.parentContainer}>
                                <div className={styles.leftContainer}>
                                    <label htmlFor="receiptTemplate" className={styles.label}>Receipt Template Statement:
                                        <HoverButton
                                            title={'Receipt template for email.'}
                                            messageWidth={75}
                                        />
                                    </label>
                                </div>
                                <div className={styles.rightContainer}>
                                    <textarea
                                        type="textarea"
                                        autoComplete="off"
                                        value={formData.receiptTemplate}
                                        name="receiptTemplate"
                                        rows="10"
                                        cols="45"
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.parentContainer}>
                        <div className={styles.leftContainer}>
                            <div className={styles.parentContainer}>
                                <div className={styles.leftContainer}>
                                    <label htmlFor="errorTemplate" className={styles.label}>Error Template Statement:
                                        <HoverButton
                                            title={'Error template for email.'}
                                            messageWidth={75}
                                        />
                                    </label>
                                </div>
                                <div className={styles.rightContainer}>
                                    <textarea
                                        type="textarea"
                                        autoComplete="off"
                                        value={formData.errorTemplate}
                                        name="errorTemplate"
                                        rows="10"
                                        cols="45"
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={styles.rightContainer}>
                            <div className={styles.parentContainer}>
                                <div className={styles.leftContainer}>
                                    <></>
                                </div>
                                <div className={styles.rightContainer}>
                                    <></>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={styles.submitButton}>
                    <button disabled={!isFormValid()} className={styles.button} onClick={handleSubmit}>
                        Submit
                    </button>
                </div>
            </>
            :
            <LoadingSpinner />
        }
        </>

    );
}

export default LeadCaptureConfig;